import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchCatalog, fetchItems, fetchSalesChannels } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import ViewCatalog from '../components/catalogs/ViewCatalog';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import _ from 'lodash';
import Pagination from '../components/home/Pagination';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  catalog: PropTypes.any,
  catalogId: PropTypes.string.isRequired,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
  items: PropTypes.array,
  itemsMeta: PropTypes.object,
  router: PropTypes.object,
  salesChannels: PropTypes.object,
};

class CatalogViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      salesChannel: {
        name: '',
        displayName: '',
        catalogId: 0,
        disabled: false,
        subdomain: '',
        campaignId: '',
        startDate: '',
        endDate: '',
        debugMode: false,
      },
      alertOpen: false,
      alertMessage: '',
      edited: false,
      itemsList: [],
      catalogItemsMap: new Map(),
    };
    autoBind(this);
  }

  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
    const query = this.props.query;
    const router = this.props.router;
    if (!query.page) {
      query.page = 1;
      query.showDisabled = false;
      query.catalogId = this.props.catalogId;
      router.push({ pathname: location.pathname, query });
    }
    this.props.dispatch(fetchItems(query));
    this.props.dispatch(fetchCatalog(this.props.catalogId));
    this.props.dispatch(fetchSalesChannels({ page: 1 }));
  }
  componentWillReceiveProps(nextProps) {
    const nextState = this.state;
    const catalog = nextProps.catalog;
    const catalogItemsMap = this.state.catalogItemsMap;
    let itemsList = [];
    if (catalog) {
      _.each(catalog.items, item => {
        catalogItemsMap.set(item.id, item);
      });

      itemsList = _.map(nextProps.items, (item) => {
        const newItem = _.clone(item);
        if (catalogItemsMap.has(item.id)) {
          newItem.inCatalog = true;
        }
        return newItem;
      });
    }
    nextState.itemsList = itemsList;

    this.setState(nextState);
  }
  navigation(route) {
    this.props.dispatch(fetchItems(route));
  }
  renderSalesChannelsDropdown() {
    return this.props.salesChannel.results.map((sc, i) =>
      <MenuItem key={i} primaryText={sc.name} />
    );
  }

  renderRowsTable() {
    return this.state.itemsList.map(item =>
      <TableRow key={item.id}>
        <TableRowColumn>{item.name}</TableRowColumn>
        <TableRowColumn>{item.productName}</TableRowColumn>
        <TableRowColumn>{item.sku}</TableRowColumn>
      </TableRow>
    );
  }
  render() {
    //     const SalesChannelTest = this.props.salesChannel.results.map((sc, i) =>
    //     <MenuItem key={i} primaryText={sc.name} />
    //  );
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const tableStyles = {
      showCheckboxes: false,
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div className="catalogs component" style={authPage}>
        <h2>View Catalog</h2>
        <div className="content">
          <ViewCatalog
            catalog={this.props.catalog}
          />
        </div>

        <h2>Catalog Items</h2>
        <div className="content">
          <div className="action-buttons top">
            <SelectField
              floatingLabelText="Sales Channels"
              value={this.state.value}
              // onChange={this.handleChange}
            >
              {this.renderSalesChannelsDropdown()}
            </SelectField>
            <Pagination
              paginationInfo={this.props.itemsMeta}
              pageCall={route => this.navigation(route)}
              pageName={`/catalogs/view/${_.get(this, 'props.catalog.id')}`}
            />
          </div>
          <Table
            wrapperStyle={{ overflow: 'inherit' }}
            selectable={tableStyles.selectable}
            multiSelectable={tableStyles.multiSelectable}
          >
            <TableHeader
              displaySelectAll={tableStyles.showCheckboxes}
              adjustForCheckbox={tableStyles.showCheckboxes}
              enableSelectAll={tableStyles.enableSelectAll}
            >
              <TableRow
                selectable={tableStyles.selectable}
              >
                <TableHeaderColumn>Name</TableHeaderColumn>
                <TableHeaderColumn>Product</TableHeaderColumn>
                <TableHeaderColumn>SKU</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              stripedRows={tableStyles.stripedRows}
              displayRowCheckbox={tableStyles.displayRowCheckbox}
            >
              {this.renderRowsTable()}
            </TableBody>
          </Table>
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.itemsMeta}
            pageCall={route => this.navigation(route)}
            pageName={`/catalogs/view/${_.get(this, 'props.catalog.id')}`}
          />
        </div>
      </div>
    );
  }
}

CatalogViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CatalogViewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    catalog: state.catalogs.catalog,
    catalogId: ownProps.params.id,
    error: state.catalogs.error,
    itemsMeta: state.items.meta,
    items: state.items.results,
    query: ownProps.location.query,
    salesChannel: state.salesChannels,

  };
}

export default withRouter(connect(mapStateToProps)(CatalogViewPage));



// WEBPACK FOOTER //
// ./src/containers/CatalogViewPage.js